import API from 'services/api';

export const getUser = (userId: number | null) => {
  return API.get(`/api/users/${userId}`).then(response => response?.data);
};
